import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StammdatenService } from '@/core/services/stammdaten.service';
import { AuthenticationConfig } from '@/core/components/authentication/authentication.module';
import { AUTHENTICATION_CONFIG } from '@/core/components/authentication/injection-tokens';

@Injectable({
  providedIn: 'root'
})
export class RegistrationIsEnabledGuard  {
  constructor( @Inject(AUTHENTICATION_CONFIG) protected authenticationConfig: AuthenticationConfig, protected stammdatenService: StammdatenService, protected router: Router){}

  async canActivate() {
    const portalkonfiguration = await this.stammdatenService.GetPortalKonfiguration().toPromise();

    if (!portalkonfiguration || portalkonfiguration.registrationIsDisabled == true)
      this.router.navigateByUrl(this.authenticationConfig.loginUrl);

    return true;
  }
}